import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@kdcloudjs/kdesign";

const themeHash = {
  "#000000": "",
  "#276FF5": "39,111,245",
  "#1BA854": "27,168,84",
  "#16B8B1": "22,184,177",
  "#701DF0": "112,29,240",
  "#FB2323": "251,35,35",
  "#FF5F1E": "255,95,30",
  "#FF991C": "255,153,28",
};
const themes = Object.keys(themeHash);

const getOpacity = (x, y) => {
  const axis = `${x}-${y}`;
  switch (axis) {
    case "2-2": {
      return [0.15, 0.3, 0.3, 0.55];
    }
    case "2-3": {
      return [0.05, 0.15, 0.15, 0.3, 0.3, 0.55];
    }
    case "3-2": {
      return [0.05, 0.15, 0.3, 0.15, 0.3, 0.55];
    }
    case "3-3": {
      return [0.05, 0.15, 0.3, 0.15, 0.3, 0.45, 0.3, 0.45, 0.7];
    }
    case "4-4": {
      return [
        0.05, 0.15, 0.3, 0.45, 0.15, 0.3, 0.45, 0.6, 0.3, 0.45, 0.6, 0.75, 0.45,
        0.6, 0.75, 1,
      ];
    }
    default:
      break;
  }
};

// 预制彩色数据
const colors = {
  "2-2": ["#FB4B30", "#23B8FD", "#23B8FD", "#58CF0B"],
  "2-3": ["#FB4B30", "#23B8FD", "#FCA300", "#2ACED2", "#23B8FD", "#58CF0B"],
  "3-2": ["#FB4B30", "#FCA300", "#23B8FD", "#23B8FD", "#2ACED2", "#58CF0B"],
  "3-3": [
    "#FB4B30",
    "#FCA300",
    "#23B8FD",
    "#FCA300",
    "#23B8FD",
    "#2ACED2",
    "#23B8FD",
    "#2ACED2",
    "#58CF0B",
  ],
  "4-4": [
    "#FB1479",
    "#FB4B30",
    "#FCA300",
    "#23B8FD",
    "#FB4B30",
    "#FCA300",
    "#23B8FD",
    "#2ACED2",
    "#FCA300",
    "#23B8FD",
    "#2ACED2",
    "#58CF0B",
    "#23B8FD",
    "#2ACED2",
    "#58CF0B",
    "#25A97A",
  ],
};

const colorMap = {
  "#FB1479": "#FB1479",
  "#FB4B30": "#FB4B30",
  "#FCA300": "#FCA300",
  "#23B8FD": "#23B8FD",
  "#2ACED2": "#2ACED2",
  "#58CF0B": "#58CF0B",
  "#25A97A": "#25A97A",
};

export { themes, themeHash, getOpacity, colors, colorMap };
